import { render, staticRenderFns } from "./CartaoListaDeSolicitacoes.vue?vue&type=template&id=34070321&scoped=true"
import script from "./CartaoListaDeSolicitacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoListaDeSolicitacoes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoListaDeSolicitacoes.vue?vue&type=style&index=0&id=34070321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34070321",
  null
  
)

export default component.exports